module.exports = __webpack_public_path__ + "static/media/-_Cloud workforce .1b28062d.png";